import React from 'react'
import { Divider } from '@mantine/core'
import Marquee from 'react-fast-marquee'

type PropType = {
  slides: number[]
}

const SponsorshipCarousel: React.FC<PropType> = props => {
  const { slides } = props
  return (
    <div className="flex ">
      <Marquee style={{ width: '80%', margin: 'auto' }}>
        <div className="flex">
          {slides.map(image => {
            const slideWidth = 105 * image.imageUrls.length // Distribute the width equally
            return (
              <div key={image.name}>
                <div className=" mx-4 ">
                  <Divider
                    my="xs"
                    size="sm"
                    label={image.name}
                    labelPosition="center"
                    sx={{
                      width:
                        slideWidth + (16 * image.imageUrls.length) / 2 + 'px',
                    }}
                  />

                  <div className=" flex gap-4 ">
                    {image.imageUrls.map((imageUrl, idx) => (
                      <img
                        key={idx}
                        className="h-[100px] w-[100px] object-contain"
                        src={imageUrl}
                        alt={image.name}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Marquee>
    </div>
  )
}

export default SponsorshipCarousel
